// extracted by mini-css-extract-plugin
module.exports = {"box":"box-zX3kN04_ clearfix"};